import React, { useEffect } from "react";
import { styled } from '@mui/material/styles';
import bannerImg from "../../../assets/images/storm-houses-pano.jpg";
import researchImg from "../../../assets/images/earth-magnetic-field.jpg";
import mitigationImg from "../../../assets/images/sun-reeds.jpg";
import responseImg from "../../../assets/images/tornados.jpg";
import recoveryImg from "../../../assets/images/flood-bench.jpg";
import exercisesImg from "../../../assets/images/radar-tower.jpg";
import planningImg from "../../../assets/images/winter-outlook.jpg";
import climateChangeImg from "../../../assets/images/climate-change.jpg";
import higherEducationImg from "../../../assets/images/higher-education.jpg";

import handleGA, { gaEvents } from "../../googleAnalytics";

const PREFIX = 'Usecases';

const classes = {
  root: `${PREFIX}-root`,

  // migrating styles to emotion: App.theme styles no longer imported from file using useStyles
  banner: `${PREFIX}-banner`,
  bannerTextBox: `${PREFIX}-bannerTextBox`,
  bannerTextBoxHeader: `${PREFIX}-bannerTextBoxHeader`,
  bannerTextBoxSubHeader: `${PREFIX}-bannerTextBoxSubHeader`,
  bannerTextBoxButton: `${PREFIX}-bannerTextBoxButton`,
  infoIcon: `${PREFIX}-infoIcon`,
  link: `${PREFIX}-link`,
  container: `${PREFIX}-container`,
  image: `${PREFIX}-image`,
  item: `${PREFIX}-item`,
  itemImage: `${PREFIX}-itemImage`,
  itemContent: `${PREFIX}-itemContent`,
  itemTitle: `${PREFIX}-itemTitle`,
  itemText: `${PREFIX}-itemText`,
  itemLink: `${PREFIX}-itemLink`,
  explore: `${PREFIX}-explore`,
  exploreHeader: `${PREFIX}-exploreHeader`,
  banner: `${PREFIX}-banner`
  
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    background: "#fff",
    display: "block",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
    },
  },

  [`& .${classes.banner}`]: {
    position: "relative",
    maxWidth: '100vw'
    },

  [`& .${classes.bannerTextBox}`]: {
    position: "absolute",
    left: "12vw",
    top: "5rem",
    display: "flex",
    flexDirection: "column",
    maxWidth: "20rem",
    background: "#fff",
    borderRadius: "5px",
    padding: "2rem",
    lineHeight: "1.5",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "16rem",
      top: "0",
      right: "0",
      bottom: "0",
      left: "0",
      margin: "2rem auto",
    },
  },

  [`& .${classes.bannerTextBoxHeader}`]: {
    color: "#0078a9",
    fontWeight: "bold",
    fontSize: "1.3rem",
    },

  [`& .${classes.bannerTextBoxSubHeader}`]: {
	margin: "1rem 0 0 0",
    },

  [`& .${classes.bannerTextBoxButton}`]: {
    background: "#0078a9",
    color: "#fff",
    textTransform: "none",
    display: "flex",
    alignSelf: "end",
    marginTop: "1.5em",
    "&:hover": {
      background: "#006c98",
    },
  },

  [`& .${classes.infoIcon}`]: {
    color: '#0078a9',
    fontSize: '0.9rem',
    margin: '0 0.25rem'
    },

  [`& .${classes.container}`]: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    maxWidth: "64rem",
    margin: "3em auto",
    [theme.breakpoints.down("sm")]: {
      margin: "3em 1em",
    },
  },

  [`& .${classes.image}`]: {
    maxHeight: "400px",
    minWidth: "100vw",
    objectFit: "cover",
    objectPosition: "bottom",
  },

  [`& .${classes.link}`]: {
    color: "#005287",
    fontWeight: "bold",
  },
  
  [`& .${classes.item}`]: {
    display: "flex",
    flexDirection: "row",
    margin: "2em 0",
    width: "45%",
    [theme.breakpoints.down("sm")]: {
      margin: "2em 0",
      width: "100%",
    },
  },

  [`& .${classes.itemImage}`]: {
    marginRight: "2rem",
    fontSize: "8rem",
    height: "8rem",
    width: "8rem",
    objectFit: "cover",
    borderRadius: "50%",
    color: "#0078a9",
    alignSelf: "start",
    overflow: "hidden !important",
    [theme.breakpoints.down("sm")]: {
      width: "6rem",
      maxWidth: "6rem",
      height: "6rem",
      fontSize: "6rem",
    },
  },

  [`& .${classes.itemContent}`]: {
    display: "flex",
    flexDirection: "column",
    lineHeight: "1.5215469613",
    flex: 1,
  },

  [`& .${classes.itemTitle}`]: {
    color: "#37783a",
    fontSize: "1.3rem",
    fontWeight: "bold",
    marginBottom: "0.5em",
  },

  [`& .${classes.itemText}`]: {},

  [`& .${classes.itemLink}`]: {
    color: "#37783a",
    display: "none",
  },

  [`& .${classes.explore}`]: {
    position: "absolute",
    left: "12vw",
    top: "10vh",
    display: "flex",
    flexDirection: "column",
    maxWidth: "20rem",
    background: "#fff",
    borderRadius: "5px",
    padding: "2rem",
    lineHeight: "1.5",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "16rem",
      top: "0",
      right: "0",
      bottom: "0",
      left: "0",
      margin: "3rem auto",
    },
  },

  [`& .${classes.exploreHeader}`]: {
    color: "#0078a9",
    fontWeight: "bold",
    fontSize: "1.3rem",
  },

  [`& .${classes.banner}`]: {
    position: "relative",
    maxWidth: "100vw",
  }
}));

const Usecases = () => {

  const images = {
    banner: bannerImg,
    research: researchImg,
    mitigation: mitigationImg,
    recovery: recoveryImg,
    response: responseImg,
    exercises: exercisesImg,
    planning: planningImg,
    climateChange: climateChangeImg,
    higherEducation: higherEducationImg,
  };

  const show = {
    mitigation: true,
    response: false,
    recovery: true,
    exercisesAndScenarios: true,
    planning: false,
    research: true,
    higherEducation: false,
    climateChange: false,
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // Google Analytics
    handleGA(gaEvents.PAGE_VIEW, window.location.pathname);
  }, []);

  useEffect(() => {
    document.title = "Explore HLL benefits and its usage | Hazus Loss Library";
    document.getElementById('description').content = "HLL is a continuously growing collection of curated natural hazard risk information that benefits Mitigation, Recovery, Research, and Scenario Planning efforts.";
  })

  return (
    <Root className={classes.root}>
      <div className={classes.banner}>
        <div className={classes.bannerTextBox}>
          <span className={classes.bannerTextBoxHeader}>Explore Use Cases</span>
          <p>
            Learn how the Hazus Loss Library is being used and how it can
            benefit you. The Hazus community is large and continues to grow as
            we expand free access to curated natural hazard risk information.
          </p>
        </div>
        <img
          src={images.banner}
          alt="a sky after storm"
          className={classes.image}
        ></img>
      </div>
      <div className={classes.container}>
        {show.mitigation && (
          <div className={classes.item}>
            <img
              className={classes.itemImage}
              src={images.mitigation}
              alt="sun over lake"
            />
            <div className={classes.itemContent}>
              <span className={classes.itemTitle}>Mitigation</span>
              <span className={classes.itemText}>
              Find Hazus studies to include in or inform your mitigation plan. 
              Review studies from FEMA and partner agencies to find new insights 
              into risk assessment modeling. Build a foundation for a community's 
              long-term strategy to reduce disaster losses and break the cycle of 
              disaster damage, reconstruction, and repeated losses. 
              Review our Mitigation Planning Use Case <a href="https://www.fema.gov/sites/default/files/documents/fema_rsl_hazus-loss-library-planning-use-case_032025.pdf" target="_blank" rel="noreferrer" aria-label="Mitigation Planning Use Case" className={classes.link}>here</a> for more information on 
              how the HLL can help in building a hazard mitigation plan.
              </span>
            </div>
          </div>
        )}
        {show.response && (
          <div className={classes.item}>
            <img
              className={classes.itemImage}
              src={images.response}
              alt="tornados"
            />
            <div className={classes.itemContent}>
              <span className={classes.itemTitle}>
                Response Operations
              </span>
              <span className={classes.itemText}>
                View FEMA’s most recent impact analyses for estimates on
                economic losses, shelter requirements, debris, and more. Compare
                modeled results and/or revise an existing model to aid in
                real-time planning.
              </span>
            </div>
          </div>
        )}
        {show.recovery && (
          <div className={classes.item}>
            <img
              className={classes.itemImage}
              src={images.recovery}
              alt="a flooded bench"
            />
            <div className={classes.itemContent}>
              <span className={classes.itemTitle}>Recovery</span>
              <span className={classes.itemText}>
                Find out if there are hindcast analyses for past disasters in
                your area. Learn about the areas most impacted in your community
                and where to invest for the future.
              </span>
            </div>
          </div>
        )}
        {show.exercisesAndScenarios && (
          <div className={classes.item}>
            <img
              className={classes.itemImage}
              src={images.exercises}
              alt="radar tower"
            />
            <div className={classes.itemContent}>
              <span className={classes.itemTitle}>
                Exercises & Scenarios
              </span>
              <span className={classes.itemText}>
                Get scenario information generated from high quality analyses
                from single or multi-hazard events. Use the data to develop
                exercises, plan for logistics and operations, and to enhance
                preparedness.
              </span>
            </div>
          </div>
        )}
        {show.planning && (
          <div className={classes.item}>
            <img
              className={classes.itemImage}
              src={images.planning}
              alt="weather forecast"
            />
            <div className={classes.itemContent}>
              <span className={classes.itemTitle}>Planning</span>
              <span className={classes.itemText}>
                Discover the hazards that affect your community. Learn about
                their frequency, severity, impact, and mitigation efforts for
                effective planning and efficient use of resources.
              </span>
            </div>
          </div>
        )}
        {show.research && (
          <div className={classes.item}>
            <img
              className={classes.itemImage}
              src={images.research}
              alt="geomagnetic fields"
            />

            <div className={classes.itemContent}>
              <span className={classes.itemTitle}>Research</span>
              <span className={classes.itemText}>
                Compare the results from our models to real historical events.
                Download data and results to build more informed models and aid
                in collaboration. Obtain completed scenarios for use in
                educational research projects. Leverage results from
                deterministic and probabilistic events to validate independent
                findings.
              </span>
            </div>
          </div>
        )}
        {show.higherEducation && (
          <div className={classes.item}>
            <img
              className={classes.itemImage}
              src={images.higherEducation}
              alt="geomagnetic fields"
            />

            <div className={classes.itemContent}>
              <span className={classes.itemTitle}>
                Higher Education
              </span>
              <span className={classes.itemText}>
                Obtain completed scenarios and recent study regions for use in
                educational research projects. Leverage results from
                deterministic and probabilistic events to validate independent
                findings.
              </span>
            </div>
          </div>
        )}
        {show.climateChange && (
          <div className={classes.item}>
            <img
              className={classes.itemImage}
              src={images.climateChange}
              alt="geomagnetic fields"
            />

            <div className={classes.itemContent}>
              <span className={classes.itemTitle}>Climate Change</span>
              <span className={classes.itemText}>
                View past models to see changes in damage results when analysis
                is modified to account for current levels of erosion, sea-level
                rise, and/or changes in land-use.
              </span>
            </div>
          </div>
        )}
      </div>
    </Root>
  );
};

export default Usecases;
